import React, { useState, useRef } from 'react';
import { TextField, Menu, MenuItem, FormControl, InputLabel, IconButton, InputAdornment } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import { getNumericOperators } from '../../list.functions';
import { useTranslation } from 'react-i18next';

const NumericFilter = ({ item, applyValue, onFilterOperatorChange }) => {
    const [operator, setOperator] = useState(item?.operator || 'equals');
    const [value, setValue] = useState(item?.value || '');
    const [focused, setFocused] = useState(false);
    const [preventBlur, setPreventBlur] = useState(false);
    const { t } = useTranslation();
    const operatorList = getNumericOperators(t)

    const inputRef = useRef(null);

    const handleKeyDown = (event) => {
        event.target.focus();
        setPreventBlur(true);
    }

    const handleFocus = (event) => {
        setFocused(true);
    }

    const handleBlur = (event) => {
        if (preventBlur) {
            event.target.focus();
            setPreventBlur(false);
        } else {
            setFocused(false);
        }
    }

    const handleValueChange = (event) => {
        const newValue = event.target.value;
        
        setValue(newValue);
        if (operator !== 'isEmpty' && operator !== 'isNotEmpty') {
            applyValue({ ...item, operator, value: newValue });
        }
        setFocused(true)
    };

    const handleValueEmpty = () => {
        setValue('');
        
        if (operator !== 'isEmpty' && operator !== 'isNotEmpty') {
            applyValue({ ...item, value: '', operator: item?.operator });
        } else {
            applyValue({ ...item, value: '', operator: 'contains' });
        }
    };

    const isValueInputDisabled = operator === 'isEmpty' || operator === 'isNotEmpty';
    const isValueEmpty = value === '' || value === null || value === undefined;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOperatorChange = (operator) => {
        setOperator(operator);

        if (onFilterOperatorChange) {
            onFilterOperatorChange(operator);
        }

        if (operator === 'isEmpty' || operator === 'isNotEmpty') {
            applyValue({ ...item, operator: operator, value: ' ' });
        } else if (value) {
            applyValue({ ...item, operator: operator, value: value });
        }

        handleClose();
    };

    return (
        <FormControl variant="standard" size="small" className='mtska-list-filter-wrapper'>
            <InputLabel shrink={focused || !isValueEmpty}>{t(operator)}</InputLabel>

            <TextField
                variant="standard"
                size="small"
                className="mtska-list-filter-value"
                value={value}
                onChange={handleValueChange}
                inputRef={inputRef}
                type={"number"}
                disabled={isValueInputDisabled}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                InputProps={!isValueEmpty ? {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                sx={{ padding: '4px' }}
                                onClick={() => handleValueEmpty()}
                            >
                                <ClearIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ),
                } : undefined}
            />

            <IconButton
                size="small"
                onClick={handleOpen}
            >
                <FilterListIcon fontSize="small" />
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {operatorList.map((operator) => (
                    <MenuItem
                        key={operator.value}
                        value={operator.value}
                        onClick={() => handleOperatorChange(operator.value)}
                    >
                        {operator.label}
                    </MenuItem>
                ))}
            </Menu>
        </FormControl>
    );
};

export default NumericFilter;
